import Links from '@/shared/constants/navegacao';
import { Fragment, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { TrocarSenha } from '@/modules/system/auth/application/auth.service';
import { useNavigate } from 'react-router-dom';

export default function TrocarSenhaIndex() {
  const navigate = useNavigate();
  const senha = useRef<HTMLInputElement>(null);
  const codigo = useRef<HTMLInputElement>(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    TrocarSenha(senha.current!.value, codigo.current!.value)
      .then(() => {
        toast.info('Senha alterada com sucesso.');
        setTimeout(() => navigate(`${Links.Auth_Login}`), 3000);
      })
      .catch((error) => {
        toast.error((error.response.data.message as string) + '');
      });
  };

  return (
    <Fragment>
      <ToastContainer position="top-center" />
      <section className="ftco-section">
        <div className="loginrow w-100 justify-content-center">
          <div
            className=""
            style={{ width: '35%', minWidth: '25%', maxWidth: '40%' }}
          >
            <div className="d-flex">
              <div className="w-100">
                <h4 className="mb-4">Trocar Senha via Código de Recuperação</h4>
              </div>
            </div>
            <form className="signin-form" onSubmit={handleSubmit}>
              <div className="loginform-group">
                <label className="loginlabel" htmlFor="codigorecuperacao">
                  Código
                </label>
                <input
                  ref={codigo}
                  title="Código recebido por e-mail"
                  id="codigorecuperacao"
                  autoComplete="username"
                  name="codigorecuperacao"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
              <div className="loginform-group">
                <label className="loginlabel" htmlFor="senha">
                  Nova Senha
                </label>
                <input
                  ref={senha}
                  title="Nova Senha"
                  id="senha"
                  name="senha"
                  type="password"
                  autoComplete="current-password"
                  className="form-control"
                  required
                />
              </div>
              <div className="loginform-group">
                <button
                  type="submit"
                  className="form-control loginbtn loginbtn-primary submit px-3"
                >
                  Trocar Senha
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </Fragment>
  );
}
